export default {
    methods: {
        getAuditUrl(id:string, entity:string):string {
            return `/auditorias?idEntity=${id}&entityList=${entity}&custom=true`
        },
    },
}
